import defaultClient from '@/plugins/axios/defaultClient'
import qs from 'query-string'

export default {
  /**
   * 뉴스 조회
   * @param {
   * {
   *  pageSize: 2
   *  ordering: createdAt(생성 날짜 기준)
   *  ordering: date(뉴스 날짜 기준)
   * }
   * } query
   * @returns
   */
  async getNews({ pageSize, ordering }) {
    return defaultClient.get(`/news?${qs.stringify({ pageSize, ordering })}`)
  },
}
